<p-popover #op styleClass='p-none' [showCloseIcon]='true'>
  <ng-template pTemplate="content">
    <div class='d-flex flex-column' [formGroup]='form()'>
      <bs-listbox [options]='originalSuggestions()' formControlName='employee' optionLabel='name' [filter]='true'
                 [listStyle]="{'max-height':'250px'}"
                 (changed)='onSelectEmployee.emit($event)' data-testid="employee-listbox">
      </bs-listbox>
      <div class='d-flex justify-content-end mt-2'>
        <ng-content></ng-content>
      </div>
    </div>
  </ng-template>
</p-popover>


@if (op.overlayVisible) {
  <div class='overlay' (click)='op.toggle($event)'></div>
}


